import Axios from 'axios';
import {DashboardData} from "../../model/clases/DashboardData";
import { Configuration } from "./Configuration";

class DashboardAPI {
  url: string = `${Configuration.apiUrl}/proxy.php`;
//  url: string = `http://localhost/mps/proxy.php`;
  create(data: DashboardData): Promise<any> {
    return Axios.post(`${this.url}`, data, {headers: {
        'Content-Type': 'multipart/form-data'
      }});
  }
}

export default DashboardAPI;
